module.exports = __webpack_public_path__ + "img/arrows.7371d428.svg";